import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { i18n } from '@/i18n';
import InfoModal from '../InfoModal.vue';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'LoadingModal',
  props: {
    title: {},
    description: {}
  },
  setup(__props: any) {

const t = i18n.t;

const props = __props;

const title = computed(() => props.title ?? t('ローディング中'));
const description = computed(() => props.description ?? t('しばしお待ちください。'));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InfoModal, {
    "modal-state": true,
    icon: "loading",
    "enable-outside-click": false
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(title.value), 1)
    ]),
    description: _withCtx(() => [
      _createTextVNode(_toDisplayString(description.value), 1)
    ]),
    _: 1
  }))
}
}

})